import React, { useState } from "react";
import bi_filter from "../../assets/icons/bi_filter.png";
import UserInfoRow from "../../components/UserInfoRow";
import avatar from "../../assets/images/avatar.png";
import TransferUserRow from "../../components/TransferUserRow";
import ProspectsTransferred from "../../components/modals/ProspectsTransferred";
import ProspectsDeleted from "../../components/modals/ProspectsDeleted";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import ProspectsCategories from "../../components/ProspectsCategories";

const ContactedPage = () => {
  const [activeTab, setActiveTab] = useState("today");
  const [isAction, setAction] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [transferPopup, setTransferPopup] = useState(false);
  const [bulkDelete, setBulkDelete] = useState(false);
  const [bulkDeletePopup, setBulkDeletePopup] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const closeModal = () => {
    setTransferPopup(false);
    setBulkDelete(false);
    setBulkDeletePopup(false);
  };

  const handleBulkDelete = () => {
    setTransfer(false);
    setAction(false);
    setBulkDelete(!bulkDelete);
  };

  const handleBulkTransfer = () => {
    setBulkDelete(false);
    setAction(false);
    setTransfer(!transfer);
  };

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const renderRows = (RowComponent) => {
    const userRows = Array(8).fill(
      <RowComponent
        userImg={avatar}
        name="Praveen Sharma"
        mobileNumber="7543389092"
        email="praveen@gmail.com"
        lastInteracted="Oct 10,2023"
        company="Oct 10,2023"
      />
    );

    return userRows.map((row, index) => (
      <React.Fragment key={index}>
        <tr>{row}</tr>
        <tr>
          <hr />
        </tr>
      </React.Fragment>
    ));
  };

  return (
    <div className="w-[100%] overflow-auto">
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Tasks" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>
      <ProspectsCategories />
      <div className="flex justify-between items-center mt-4 w-[95%]">
        <div className="flex mx-4 text-[14px]">
          {["today", "tomorrow", "week"].map((tab, index) => (
            <div
              key={tab}
              className={`border border-[#2F80ED] px-6 py-2 ${
                index === 0 ? "rounded-l-lg" : index === 2 ? "rounded-r-lg" : ""
              } cursor-pointer ${activeTab === tab ? "active-days" : ""}`}
              onClick={() => handleActiveTab(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </div>
          ))}
        </div>
        <div className="relative flex items-center">
          <div
            className="flex items-center px-4 bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2 text-[#3485BB]"
            onClick={() => setAction(!isAction)}
          >
            <div className="text-[12px]">Action</div>
            <span className="text-md ml-2 p-1 font-semibold rotate-90">
              {">"}
            </span>
          </div>
          <div className="cursor-pointer w-10">
            <img src={bi_filter} alt="filter" />
          </div>
          {isAction && (
            <div className="absolute mt-24">
              <div className="flex flex-col items-center w-[6rem] bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2">
                <div className="text-[12px] py-1" onClick={handleBulkDelete}>
                  Bulk Delete
                </div>
                <div className="text-[12px] py-1" onClick={handleBulkTransfer}>
                  Bulk Transfer
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="ml-4 my-4 w-[95%]">
        {transfer && (
          <div className="my-4">
            <p className="text-[14px] font-bold">Bulk Transfer</p>
            <p className="text-[12px] italic text-[#7E7E7E] mt-1">
              Select contacts which you want to transfer
            </p>
            <p className="text-[14px] italic text-[#7E7E7E] mt-4">
              Transfer to
            </p>
            <select
              name="Search & select the person"
              className="border w-[50%] p-2 rounded-lg border-[#95C2FF] text-[16px]"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="" disabled hidden>
                Search & select the person
              </option>
              <option value="Praveen Sharma">Praveen Sharma</option>
            </select>
          </div>
        )}
        {bulkDelete && (
          <div className="my-4">
            <p className="text-[14px] font-bold">Bulk Delete</p>
            <p className="text-[12px] italic text-[#7E7E7E] mt-1">
              Select contacts which you want to delete
            </p>
          </div>
        )}

        <div className="flex text-[12px]  w-full ">
          <div className="px-16 py-3 bg-[#F9FAFB]">Name</div>
          <div className="px-24 py-3 bg-[#F9FAFB]">Mobile Number</div>
          <div className="px-10 py-3 bg-[#F9FAFB]">Email address</div>
          <div className="px-24 py-3 bg-[#F9FAFB]">Last interacted</div>
          <div className="px-10 py-3 bg-[#F9FAFB]">Company/Store</div>
          <div className="w-[10rem] px-16 py-3 bg-[#F9FAFB]"></div>
        </div>
        <table className="w-full">
          <tbody>
            {!transfer && !bulkDelete && renderRows(UserInfoRow)}
            {transfer && renderRows(TransferUserRow)}
            {bulkDelete && renderRows(TransferUserRow)}
          </tbody>
        </table>

        {transferPopup && <ProspectsTransferred closeModal={closeModal} />}
        {bulkDeletePopup && <ProspectsDeleted closeModal={closeModal} />}
      </div>
    </div>
  );
};

export default ContactedPage;
